module.exports = _IndicoCoreReactDom;